// TODO: rewrite without reassign
/* eslint no-param-reassign: 0 */
import { _ } from 'wgnet-awesomejs';
import $ from 'jquery';
import URI from 'urijs';

import Backbone from './lib/backbone';
import { enableCsrfToken } from './lib/backbone_wg_ajax';
import './lib/components';

import mobile from './mobile';
import base from './base';
import Settings from './lib/settings_model';


window.Application = new Backbone.View();

window.Application.on('mobile-browser-detected-onload', (options) => {
    const isPopup = URI.parseQuery(window.location.search).display === 'popup';
    const isDesktop = !isPopup && (!options.detected || options.forceDesktop);

    if (isPopup) {
        $('.js-header').hide();
    }

    if (!isDesktop) {
        if (isPopup && !options.useMobile) {
            window.Application.trigger('enable-mobile-styles');
        }
    }
});

mobile();
base();

const isSameOrigin = function isSameOrigin(url) {
    const parseUrl = URI.parse(url) || {};
    const sitePath = Settings.get('App.SitePath');

    if (!_.isUndefined(parseUrl.hostname) && parseUrl.hostname !== window.location.hostname) {
        return false;
    }

    if (parseUrl.path === '') {
        return true;
    }

    const sitePathIntex = parseUrl.path.indexOf(sitePath);

    if (sitePathIntex === 0) {
        return true;
    }

    if (sitePathIntex === -1 && parseUrl.path.charAt(0) !== '/') {
        return true;
    }

    return false;
};
const HtmlForms = {
    create(method, url, params, target, sendCsrfToken) {
        const $form = $('<form>');

        $form.attr('method', method).attr('action', url);

        if (target) {
            $form.attr('target', target);
        }

        if (params) {
            $.each(params, (key, value) => $('<input type="hidden">')
                .attr('name', key)
                .attr('value', value)
                .appendTo($form));
        }

        if (_.isUndefined(sendCsrfToken)) {
            sendCsrfToken = true;
        }
        if (typeof method === 'string') {
            method = method.toUpperCase();
        }
        if (sendCsrfToken && method === 'POST' && isSameOrigin(url)) {
            $('<input type="hidden">')
                .attr('name', 'csrfmiddlewaretoken')
                .attr('value', enableCsrfToken('wgni'))
                .appendTo($form);
        }

        $form.appendTo('body');
        return $form;
    },
    send(method, url, params, target, sendCsrfToken) {
        const $form = this.create(method, url, params, target, sendCsrfToken);

        $form.submit();
    },
    sendGet(url, params, target) {
        return this.send('GET', url, params, target);
    },
    sendPost(url, params, target, sendCsrfToken) {
        return this.send('POST', url, params, target, sendCsrfToken);
    }
};

window.Application.on('menu-logout', (event, data) => {
    const params = { return_to: _.extract(data, 'returnTo') };
    const logoutUrl = Settings.get('Authentication.LogoutUrl');
    const method = Settings.get('Authentication.LogoutMethod');

    if (method === 'get') {
        HtmlForms.sendGet(logoutUrl, params);
    } else {
        HtmlForms.sendPost(logoutUrl, params);
    }

    event.preventDefault();
});



// WEBPACK FOOTER //
// ./static-source/js/global.js